module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_rwanda-039b34a5.png";